import Calendar from "./Calendar";
// import Loadable from "../../react-loadable";
// const Calendar = Loadable({
//   loader: () => import("./Calendar"),
//   loading: () => <div style={{ width: 231, height: 314 }} />,
//   render: (obj, props, ref) => {
//     if (obj) {
//       return React.createElement(obj && obj.__esModule ? obj.default : obj, {
//         ...props,
//         ref
//       });
//     }
//     return null;
//   }
// });
export default Calendar;



// WEBPACK FOOTER //
// ./_rc-calendar-5.6.2/src/index.js